import { useQuery } from "@tanstack/react-query"
import { getDataDashboard } from "../api/dashboard"

const _DASHBOARD_DATA = 'data_statistic'
export const useGetDataDashboard = (year?: number ) => {
    return useQuery([_DASHBOARD_DATA, year],
        async () => {
            return await getDataDashboard(year);
        }
    );
};